import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Search, Package } from "lucide-react";
import useSEO from "../hooks/useSEO";
import { api, euro } from "../lib/api";

export default function Onderdelen() {
  useSEO({
    title: "Motoronderdelen & accessoires Torhout — alle merken | TT Motorsports",
    description: "Motoronderdelen en motor accessoires voor alle merken in Torhout. Originele en aftermarket onderdelen, snel geleverd en vakkundig gemonteerd bij TT Motorsports.",
    keywords: "motoronderdelen, motor onderdelen, motor accessoires, originele onderdelen, aftermarket onderdelen, TT Motorsports Torhout",
  });

  const [parts, setParts] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const t = setTimeout(() => {
      api.get("/parts", { params: q ? { q } : {} }).then((r) => setParts(r.data)).finally(() => setLoading(false));
    }, 250);
    return () => clearTimeout(t);
  }, [q]);

  return (
    <div data-testid="onderdelen-page">
      <section className="pt-36 pb-12 bg-[#0A0A0B] border-b border-[#2A2B31] relative overflow-hidden">
        <div className="absolute top-0 right-0 w-1/3 h-full racing-stripe opacity-[0.04]" />
        <div className="max-w-[1400px] mx-auto px-5 md:px-8 relative">
          <span className="font-mono-tt uppercase text-xs tracking-[0.3em] text-[#E10600]">Shop</span>
          <h1 className="heading-xl text-5xl md:text-7xl text-white mt-3">Onderdelen</h1>
          <p className="text-[#9A9CA3] text-lg mt-4 max-w-2xl">Originele en aftermarket onderdelen en accessoires voor je motor.</p>
        </div>
      </section>

      <section className="section-pad bg-[#0A0A0B]">
        <div className="max-w-[1400px] mx-auto px-5 md:px-8">
          <div className="relative max-w-md mb-10">
            <Search size={18} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-[#5A5C63]" />
            <input data-testid="parts-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Zoek een onderdeel..."
              className="w-full bg-[#141518] border border-[#2A2B31] pl-11 pr-4 py-3.5 text-white focus:outline-none focus:border-[#E10600]" />
          </div>

          {loading ? (
            <p className="text-[#9A9CA3] font-mono-tt">Laden...</p>
          ) : parts.length === 0 ? (
            <div className="border border-[#2A2B31] p-16 text-center">
              <Package size={40} className="text-[#2A2B31] mx-auto mb-4" />
              <p className="font-display uppercase text-2xl text-white mb-2">Geen onderdelen gevonden</p>
              <p className="text-[#9A9CA3]">Neem contact met ons op — we bestellen graag wat je nodig hebt.</p>
            </div>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {parts.map((p, i) => (
                <motion.div key={p.id} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 4) * 0.05 }}
                  data-testid={`part-card-${p.id}`} className="group bg-[#141518] border border-[#2A2B31] hover:border-[#E10600]/60 transition-colors overflow-hidden">
                  <div className="aspect-square overflow-hidden bg-[#0A0A0B]">
                    <img src={p.image || "https://images.unsplash.com/photo-1558981403-c5f9899a28bc?w=600"} alt={p.naam} loading="lazy" className="w-full h-full object-cover card-hover-img" />
                  </div>
                  <div className="p-5">
                    {p.categorie && <p className="font-mono-tt text-[10px] uppercase tracking-widest text-[#E10600] mb-1">{p.categorie}</p>}
                    <h3 className="font-display uppercase font-700 text-lg text-white leading-tight mb-2">{p.naam}</h3>
                    {p.omschrijving && <p className="text-[#9A9CA3] text-sm mb-4 line-clamp-2">{p.omschrijving}</p>}
                    <div className="flex items-center justify-between pt-3 border-t border-[#2A2B31]">
                      <span className="font-display font-800 text-xl text-white">{euro(p.prijs)}</span>
                      <span className={`font-mono-tt text-[11px] uppercase tracking-wider ${p.beschikbaar ? "text-green-500" : "text-[#9A9CA3]"}`}>
                        {p.beschikbaar ? "Op voorraad" : "Uitverkocht"}
                      </span>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
